module.exports = __webpack_public_path__ + "img/Trans-Poses_0000_CJ.12ed3919.png";